import styled from 'styled-components'
import { Typography } from '../typography/typography'
import { WarningIcon } from '../../../assets/icons'

export const TextAreaErrorWrapper = styled.div`
  display: flex;
  margin-top: 5px;
  margin-bottom: -12px;
  gap: 8px;
`

export const ErrorIcon = styled(WarningIcon)`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`

export const ErrorTypography = styled(Typography)`
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.error.main};
  font-family: 'Inter', sans-serif;
`
